import React, {useEffect, useState} from 'react'
import {PageTitle} from 'layout/master-layout'
// import {toast} from 'react-toastify'
// import Spinner from 'layout/common/Spinner'
// import {useTranslation} from 'react-i18next'
// import {ILogin} from 'models/Auth'
import {ITab, KTTab} from 'helpers/ui-components/KTTab'
import BasicProfile from './BasicProfile'
import AccountSettings from './AccountSettings'
import CompanyProfile from './CompanyProfile'
import Spinner from 'layout/common/Spinner'
import {fetchParentOnboardingItmesConfig} from 'utils/api/auth/myAccountService'
import {
 IItmesConfig,
 IItmesConfigList,
} from 'models/GenericForm'
import {useAuth} from 'context/AuthProvider'
import BusinessProfile from './BusinessProfile/Index'
import {useParams} from 'react-router-dom'
import {useTranslation} from 'react-i18next'

type Props = {
 userId?: string
 userCategoryKey?: string
}

export const MyAccountPage = (props: Props) => {
 //  const {t} = useTranslation()
 //  const navigate = useNavigate()
 const {id} = useParams()
 const {userData} = useAuth()
 const [loader, setLoader] = useState(false)
 const [parentItemConfigList, setParentItemConfigList] =
  useState<IItmesConfigList>()
 const [tabList, setTabList] = useState<ITab[]>([])
 const [activeTab, setActiveTab] = useState('')
 const userAccess = props.userId
  ? userData?.userSubModule?.userManagement?.userDetails
     ?.section
  : userData?.userSubModule?.myAccount?.userDetails?.section

 const userId =
  id ?? props.userId ?? userData?.userId?.toString() ?? ''
 const userCategoryKey = props.userCategoryKey ?? ''

 const setOnboardingItmes = async () => {
  if (userData) {
   setLoader(true)
   const parentRes: IItmesConfig[] | undefined =
    await fetchParentOnboardingItmesConfig(userId)
   if (parentRes) {
    const tabs: ITab[] = []
    const itemConfigList: IItmesConfigList = {}
    parentRes.map(async (val: IItmesConfig) => {
     tabs.push({
      title: val.name,
      id: val.item_identifier,
      icon:
       val.status === 'COMPLETED' ||
       val.status === 'VERIFIED'
        ? '/media/icons/success.svg'
        : '/media/icons/error.svg',
     })
     itemConfigList[val.item_identifier] = val
    })
    setParentItemConfigList(itemConfigList)
    setTabList(tabs)
   }
   setLoader(false)
  }
 }
 const handleTabClick = (index: string) => {
  setActiveTab(index)
 }

 const reloadTabs = async () => {
  await setOnboardingItmes()
 }

 useEffect(() => {
  if (userData) {
   void setOnboardingItmes()
  }
 }, [userData])

 return (
  <>
   {loader && <Spinner />}
   <div className='w-full min-h-full'>
    <KTTab
     activeTabId={activeTab}
     containerClass='my-6'
     tabHeaderContainerClass='mb-6 !justify-start'
     tabHeaderClass='px-[20px]'
     activeClass='text-[#4E83E4] font-semibold border-b-[3px] border-[#4E83E4] '
     onClick={handleTabClick}
     tabs={tabList}
     disableHash={!!props?.userId}
     tabContent={
      <div>
       {activeTab === 'basic_profile' ? (
        <BasicProfile
         accessDetails={userAccess}
         userId={userId}
         parentItemConfig={
          parentItemConfigList?.[activeTab]
         }
         loader={loader}
         setLoader={setLoader}
         reloadTabs={reloadTabs}
        />
       ) : activeTab === 'account_settings' ? (
        <AccountSettings
         accessDetails={userAccess}
         userId={userId}
         parentItemConfig={
          parentItemConfigList?.[activeTab]
         }
         loader={loader}
         setLoader={setLoader}
         reloadTabs={reloadTabs}
        />
       ) : activeTab === 'company_profile' ? (
        <CompanyProfile
         accessDetails={userAccess}
         userId={userId}
         parentItemConfig={
          parentItemConfigList?.[activeTab]
         }
         loader={loader}
         setLoader={setLoader}
         reloadTabs={reloadTabs}
        />
       ) : activeTab === 'business_profile' ? (
        <BusinessProfile
         accessDetails={userAccess}
         userId={userId}
         userCategoryKey={userCategoryKey}
         loggedInUserId={userData?.userId}
         parentItemConfig={
          parentItemConfigList?.[activeTab]
         }
         loader={loader}
         setLoader={setLoader}
         reloadTabs={reloadTabs}
        />
       ) : (
        <></>
       )}
      </div>
     }
    />
   </div>
  </>
 )
}

export default function MyAccountPageWrapper() {
 // for using different languages and changing the text in to other languages
 // const intl = useIntl()
 const {t} = useTranslation()
 return (
  <div className='container'>
   <div className='px-[72px] pt-6 pb-[200px] bg-white'>
    <PageTitle
     breadcrumbContainerClass={
      'flex text-[#5A6066] text-sm font-normal items-center pb-6 border-[#E6EBF0] border-b'
     }
     breadcrumbs={[
      {
       title: t('breadCrumbs.home'),
       path: '/home-page',
       isActive: false,
      },
      {
       title: t('breadCrumbs.myAccount'),
       path: '',
       isActive: true,
      },
     ]}
     description='Welcome'
    >
     {t('breadCrumbs.home')}
    </PageTitle>
    <MyAccountPage />
   </div>
  </div>
 )
}
